<template>
    <v-dialog v-model="dialog" max-width="690">
        <v-card elevation="0" class="card-save-petty pt-4 pb-4">
            <v-form ref="savePettyCashForm" lazy-validation>
                <v-row no-gutters class="standard-row font-theme pb-1" align="center">
                    <v-col cols="12" sm="auto" md="auto" lg="auto" style="font-size: 16px; font-weight: 700"
                        class="text-center pl-sm-6">
                        ตัดงบเงินสดย่อย 
                    </v-col>
                    
                    <v-col cols="12" sm="auto" md="auto" lg="auto" style="font-size: 16px;"
                        class="text-center pl-3">
                        {{cutPettyCashData[0].document_id}}
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="auto" md="auto" lg="auto" class="pl-6 pl-sm-0 ml-sm-5">
                        <v-radio-group class="mt-0 pt-0" hide-details row v-model="cutPettyCashData[0].in_budget" :rules="[ v => v !== null && v !== undefined  ]" required>
                            <v-radio class="font-theme" :value="true" color="#D9D9D9" on-icon="mdi-checkbox-marked"
                                off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                <template v-slot:label>
                                    <span class="check-box-petty-cash-modal">ในงบประมาณ</span>
                                </template>
                            </v-radio>
                            <v-radio class="font-theme" :value="false" color="#D9D9D9" on-icon="mdi-checkbox-marked"
                                off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                <template v-slot:label>
                                    <span class="check-box-petty-cash-modal">นอกงบประมาณ</span>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-row no-gutters class="standard-row font-theme pl-6 pr-2 pt-7" align="center">
                        <v-col cols="12" sm="6" md="4" lg="4">
                            <v-row no-gutters class="standard-row font-theme pt-2" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px">
                                    งบประมาณปี
                                </v-col>
                                <v-col cols="5" sm="12" md="6" lg="6">
                                    <v-text-field height="24" color="black" hide-details outlined v-model="thisYear"
                                        class="pr-4 text-box-petty-cash-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4">
                            <v-row no-gutters class="standard-row font-theme pt-2" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px">
                                    Type Budget
                                </v-col>
                                <v-col cols="5" sm="12" md="6" lg="6">
                                    <v-select :items="pettyCashPermissionTab" v-model="cutPettyCashData[0].budget_type" item-text="type" @change="getGroupBudget(0)"
                                        hide-details outlined dense height="24" append-icon="mdi-chevron-down"
                                        item-color="#D9D9D9" color="black"
                                        class="pr-4 dropdown-external-petty-cash-modal">
                                        <template v-slot:item="data">
                                            <v-list-item-content class="py-0">
                                                <v-list-item-title class="font-theme"
                                                    style="font-size: 12px; line-height: 30px;">{{ data.item }}</v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content class="py-0">
                                                    <v-list-item-title class="font-theme"
                                                        style="font-size: 12px; line-height: 30px;">ไม่พบข้อมูล</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="standard-row font-theme pl-6 pr-2 pt-3" align="center">
                        <v-col cols="12" sm="6" md="4" lg="4">
                            <v-row no-gutters class="standard-row font-theme pt-2" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px">
                                    Start Date
                                </v-col>
                                <v-col cols="5" sm="12" md="6" lg="6">
                                    <v-menu :close-on-content-click="false" offset-y min-width="auto"
                                        v-model="dateStart" transition="scale-transition">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field height="24" color="black" hide-details readonly outlined
                                                v-on="on" :value="startDateTextShow"  :rules="[rules.required]" required
                                                class="pr-4 text-box-save-budget-modal"></v-text-field>
                                        </template>
                                        <v-date-picker color="#0B68D6" no-title show-current locale="th"
                                            v-model="start_date" :max="end_date" @change="dateMenuReset" @input="dateStart = false"
                                            class="font-theme date-picker-save-budget-modal"></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4">
                            <v-row no-gutters class="standard-row font-theme pt-2" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px">
                                    End Date
                                </v-col>
                                <v-col cols="5" sm="12" md="6" lg="6">
                                    <v-menu :close-on-content-click="false" offset-y min-width="auto" v-model="dateEnd"
                                        transition="scale-transition">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field height="24" color="black"  hide-details readonly outlined
                                                v-on="on" :value="endDateTextShow" :rules="[rules.required]" required
                                                class="pr-4 text-box-save-budget-modal"></v-text-field>
                                        </template>
                                        <v-date-picker color="#0B68D6" no-title show-current locale="th"
                                            v-model="end_date" :min="start_date" @change="dateMenuReset" @input="dateEnd = false"
                                            class="font-theme date-picker-save-budget-modal"></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="standard-row font-theme pl-6 pr-2 pt-3" align="center">
                        <v-col cols="12" sm="6" md="4" lg="4">
                            <v-row no-gutters class="standard-row font-theme pt-2" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px">
                                    งบที่บันทึก
                                </v-col>
                                <v-col cols="5" sm="12" md="6" lg="6">
                                    <v-text-field height="24" readonly color="black" v-model="cutPettyCashData[0].total_amount"
                                        background-color="#EAEAEA" hide-details outlined
                                        class="pr-4 text-box-petty-cash-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4">
                            <v-row no-gutters class="standard-row font-theme pt-2" align="center">
                                <v-col cols="5" sm="12" md="6" lg="6" style="font-size: 14px">
                                    Sub Team
                                </v-col>
                                <v-col cols="5" sm="12" md="6" lg="6">
                                    <v-text-field height="24" color="black" hide-details outlined v-model="cutPettyCashData[0].sub_team"
                                        class="pr-4 text-box-petty-cash-modal"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <!--------------------------------------------------- group --------------------------------------------------->
                    <v-row no-gutters class="standard-row font-theme my-5 px-4" align="center">
                        <v-row no-gutters class="standard-row font-theme pb-3" align="center"
                            style="border:  1px solid #a8a8a8; border-radius: 18px">
                            <v-row no-gutters v-for="(product, index) in cutPettyCashData[0].item" :key="`${index}`" class="standard-row font-theme mt-3 mx-3" align="center">
                                <v-col cols="12" sm="12" md="2" lg="2"
                                    class="d-flex justify-center mr-2 item-group-petty-cash-modal name-first-item-header-save-petty-cash-modal">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="font-theme text-center px-2 px-md-1" v-on="on" v-bind="attrs">{{ product?.detail }}</span>
                                        </template>
                                        <span class="font-theme">{{ product?.detail }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip top :disabled="product.group[0].group?.group_name? false : true">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete hide-details outlined dense :items="product?.group[0]?.dropdown_list" v-model="product.group[0].group" @change="getGroupBudget(1, product.group[0].group.group_id, index)" :loading="product.group[0]?.loading_status" v-on="on" v-bind="attrs" placeholder="Group" item-text="group_name" height="28" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[ v => !!v && !!v.group_id && !!v.group_name ]" required class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                        </template>
                                        <span class="font-theme">{{ product.group[0].group?.group_name }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip top :disabled="product.group[1].group?.group_name? false : true">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete hide-details outlined dense :items="product?.group[1]?.dropdown_list" v-model="product.group[1].group" @input="getGroupBudget(2, product.group[1].group.group_id, index)" :loading="product.group[1]?.loading_status" :disabled="(product.group[0]?.group?.group_id && !product.group[1]?.loading_status)? false : true" v-on="on" v-bind="attrs" placeholder="Sub 1" item-text="group_name" height="28" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[  v => (product?.group[1]?.dropdown_list?.length === 0) || (!!v && !!v.group_name)]" class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                        </template>
                                        <span class="font-theme">{{ product.group[1].group?.group_name }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip top :disabled="product.group[2].group?.group_name? false : true">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete  hide-details outlined dense :items="product?.group[2]?.dropdown_list" v-model="product.group[2].group" @change="getGroupBudget(3, product.group[2].group.group_id, index)" :loading="product.group[2]?.loading_status" :disabled="(product.group[1]?.group?.group_id && !product.group[2]?.loading_status)? false : true" v-on="on" v-bind="attrs" placeholder="Sub 2" item-text="group_name" height="28" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[  v => (product?.group[2]?.dropdown_list?.length === 0) || (!!v && !!v.group_name)]" class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                        </template>
                                        <span class="font-theme">{{ product.group[2].group?.group_name }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="12" md="2" lg="2" class="mr-n4 mt-3 mt-md-0">
                                    <v-tooltip top :disabled="product.group[3].group?.group_name? false : true">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-autocomplete hide-details outlined dense :items="product?.group[3]?.dropdown_list" v-model="product.group[3].group" item-text="group_name" :loading="product.group[3]?.loading_status" :disabled="(product.group[2]?.group?.group_id && !product.group[3]?.loading_status)? false : true" v-on="on" v-bind="attrs" height="28" append-icon="mdi-chevron-down" placeholder="Sub 3" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object :rules="[  v => (product?.group[3]?.dropdown_list?.length === 0) || (!!v && !!v.group_name)]" class="font-theme pr-md-6 dropdown-group-save-budget-modal">
                                                <template v-slot:item="data">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{ data.item.group_name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-theme" style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                        </template>
                                        <span class="font-theme">{{ product.group[3].group?.group_name }}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="10" sm="" md="2" lg="2"
                                    class="d-flex justify-center item-group-petty-cash-modal mt-3 mt-md-0 name-last-item-header-save-petty-cash-modal">
                                    {{ product?.amount }}
                                </v-col>
                                <v-col cols="2" sm="auto" md="" lg=""
                                    class="d-flex justify-center mt-3 mt-md-0 pl-3 pl-md-0">
                                    <v-btn color="#0B68D6" width="44" height="28"
                                        class="calendar-btn-save-petty-cash-modal" @click="openPlanPettyCashModal(product, index)">
                                        <img src="../assets/icon-calendar.png" contain style="height: 18px" />
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-row>
                        <v-row no-gutters class="standard-row font-theme pl-3 pr-2" align="center">
                            <v-col cols="12" sm="12" md="12" lg="12" class="mt-3 mr-md-n3">
                                <v-row no-gutters class="standard-row font-theme">
                                    <v-col cols="5" sm="12" md="2" lg="2" style="font-size: 14px;" class="mr-md-n3">
                                        Remark
                                    </v-col>
                                    <v-col cols="7" sm="12" md="8" lg="8">
                                        <v-textarea hide-details outlined rows="3" color="black" v-model="cutPettyCashData[0].remark"
                                            class="pr-4 pr-md-0 pr-lg-4 remark-textarea-save-petty-cash-modal"></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-row>
                </v-row>
                <v-row no-gutters class="standard-row font-theme pr-7 d-flex justify-end" align="center">
                    <v-btn :disabled="!disabledBtnBudget" height="32" width="74" color="#0B68D6" @click="confirmAddSavePettyCash()" style="
            box-shadow: none;
            color: white;
            border-radius: 5px;
            font-weight: 600;
            font-size: 16px;
            letter-spacing: 0.1px;
            
          ">
                        ยืนยัน
                    </v-btn>
                </v-row>
                <PlanPettyCashModal ref="PlanPettyCashModalDialog" />
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
import PlanPettyCashModal from '../components/PlanPettyCashModal.vue'
export default {
    components: {
        PlanPettyCashModal
    },
    data: () => ({
        rules: {
            required: v => !!v || 'Required.',
        },
        cutPettyCashData: [
            {
                "sub_team": null,
                "in_budget": null,
                "remark": null,
            }
        ],
        disabledBtnBudget: true,
        thisYear: new Date().getFullYear() + 543,
        selectorTypeBudget: '',
        dateStart: false,
        dateEnd: false,
        start_date: new Date().toISOString().substr(0, 10),
        end_date: new Date().toISOString().substr(0, 10),
        dialog: false,
        data212: ['Unit', 'Month', 'Year', 'Job', 'License', 'Person'],
        type_year_selected: 'ภายในปี',
        year_selected_start: null,
        year_selected_end: null,
        item_year: {
            from: [],
            to: []
        }
    }),
    mounted() {
        this.getYearList()
        EventBus.$on('toSavePetty', this.open);
        EventBus.$on('afterPlanPettyCash',this.updatePlanBudget);
    },
    beforeDestroy() {
        EventBus.$off('toSavePetty');
        EventBus.$off('afterPlanPettyCash');
    },
    watch: {
        "dialog"(newVal) {
            if (!newVal) {
                this.cutPettyCashData[0].sub_team = null;
                this.cutPettyCashData[0].in_budget = null;
                this.cutPettyCashData[0].remark = null;
                this.$refs.savePettyCashForm.resetValidation()
                this.checkDataSavePettyCash()
            }
        },
    },
    computed: {
        startDateTextShow() {
            return MainFunction.shortDate(this.start_date || null)
        },
        endDateTextShow() {
            return MainFunction.shortDate(this.end_date || null)
        },
        pettyCashPermissionTab() {
            return this.$store.state.pettyCashPermissionTab
        },
        selectedBiz() {
            return this.$store.state.confirmSelectedBiz
        },
    },

    methods: {
        open(data) {
            this.dataFromCreatePage = data;
            this.cutPettyCashData = data;
            this.cutPettyCashData[0].in_budget = true;
            // this.cutPettyCashData.budget_type = data[0].budget_type;
            // this.cutPettyCashData.item = data[0].item;
            // this.cutPettyCashData.total_amount = MainFunction.addComma(data[0].total_amount);
            this.getGroupBudget(0);
                if (this.cutPettyCashData.length > 0) {
                    setTimeout(() => {
                        this.dialog = true
                    }, 500);
                    }
        },
        updatePlanBudget(tempData = {}) {
            if (!Object.keys(tempData).length === 2) {
                return
            }
            this.cutPettyCashData[0].item[tempData.index].plan = tempData.period
            this.cutPettyCashData[0].item[tempData.index].net =  tempData.net
            this.cutPettyCashData[0].item[tempData.index].discount = tempData.discount
            this.cutPettyCashData[0].discount = MainFunction.addComma(this.cutPettyCashData[0].item.reduce((total, next) => total + Number(next.discount.replace(/,/g, '')) , 0).toFixed(2))
            this.cutPettyCashData[0].net = MainFunction.addComma(this.cutPettyCashData[0].item.reduce((total, next) => total + Number(next.net.replace(/,/g, '')), 0).toFixed(2))
        },
        // dateTime() {
        //     const tempStartDate = new Date(this.start_date);
        //     const tempEndDate = new Date(this.end_date);
        //     this.planPettyCashCount = Math.floor((tempEndDate.getTime() - tempStartDate.getTime()) / (1000 * 60 * 60 * 24)) + 1
        // },
        async getGroupBudget(key, groupId = null, index = 0) {
            if (key === 0) {
                for (let i = 0; i < this.cutPettyCashData[0].item.length; i++) {
                    const tempGroup = {
                        "level"          : null,
                        "group"          : null,
                        // "group_id"       : null,
                        // "group_name"     : null,
                        "loading_status" : false,
                        "dropdown_list"  : [],
                    }
                    this.cutPettyCashData[0].item[i].group = []
                    this.cutPettyCashData[0].item[i].plan  = []

                    this.cutPettyCashData[0].item[i].currency_exchange ||= "1";
                    this.cutPettyCashData[0].item[i].item_id =
                    this.cutPettyCashData[0].item[i].discount = this.cutPettyCashData[0].item[i].discount ? MainFunction.addComma(Number(this.cutPettyCashData[0].item[i].discount?.replace(/,/g, '') * Number(this.cutPettyCashData[0].item[i].currency_exchange?.replace(/,/g, ''))).toFixed(2)) : '0.00'
                    this.cutPettyCashData[0].item[i].total_product_price = ((Number(this.cutPettyCashData[0].item[i].amount?.replace(/,/g, '')) * Number(this.cutPettyCashData[0].item[i].currency_exchange?.replace(/,/g, ''))).toFixed(2) || '0.00').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '0.00'
                    this.cutPettyCashData[0].item[i].net = MainFunction.addComma((Number(this.cutPettyCashData[0].item[i].total_product_price?.replace(/,/g, '')) - Number(this.cutPettyCashData[0].item[i].discount?.replace(/,/g, ''))).toFixed(2) || '0.00')

                    for (let j = 0; j <= 3; j++) {
                        this.cutPettyCashData[0].item[i].group.push({ 
                            ...tempGroup,
                            "level"          : j,
                            "loading_status" : j === 0? true : false
                        }) 
                    }              
                }
            } else {
                const propsForClearData = {
                    '1' : ['1', '2', '3'],
                    '2' : ['2', '3'],
                    '3' : [],
                }
                if (!groupId) {
                    propsForClearData[key - 1].forEach((e, i) => {
                        if (i !== 0) {
                            this.cutPettyCashData[0].item[index].group[e].group = null
                            this.cutPettyCashData[0].item[index].group[e].dropdown_list = []
                        }
                    })
                    this.$forceUpdate()
                    return
                } else {
                    propsForClearData[key].forEach(e => {
                        this.cutPettyCashData[0].item[index].group[e].group         = null
                        this.cutPettyCashData[0].item[index].group[e].dropdown_list = []
                    })
                    this.cutPettyCashData[0].item[index].group[key].loading_status = true
                }
            }
            this.$forceUpdate()
            this.disabledBtnBudget  = false;
            try {
                let { data } = await this.axios.post(`${this.$api_url}/group_budget/api/v1/get_group_budget`, {
                    "tax_id"           : this.selectedBiz?.tax_id  || null,
                    "budget_type"      : [ this.cutPettyCashData[0].budget_type ] || null,
                    "upper_group_id"   : groupId || [],
                    "first_year"       : new Date().getFullYear(),
                    "last_year"        : new Date().getFullYear(),
                })
                if (data.status && data.data.length) {
                    // for (let i = 0; i < data.data.length; i++) {
                    //     data.data[i].group_id = data.data[i].group_id
                    //     delete data.data[i]._id
                    // }
                    if (key === 0) {
                        for (let i = 0; i < this.cutPettyCashData[0].item.length; i++) {
                            this.cutPettyCashData[0].item[i].group[0].dropdown_list = data.data
                        }
                    } else {
                        this.cutPettyCashData[0].item[index].group[key].dropdown_list = data.data
                        // this.cutPettyCashData.item[index].group[key].dropdown_list.unshift({"_id": null, 'group_name': 'ไม่มี'})
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.disabledBtnBudget  = true;
                if (key === 0) {
                    for (let i = 0; i < this.cutPettyCashData[0].item.length; i++) {
                        this.cutPettyCashData[0].item[i].group[0].loading_status = false
                    }
                } else {
                    this.cutPettyCashData[0].item[index].group[key].loading_status = false
                }
                this.$forceUpdate()
            }
        },
        openPlanPettyCashModal(product,indexProduct) {
            if (this.$refs.savePettyCashForm.validate()) {
                const tempData = {
                    "index"                     : indexProduct,
                    "end_date"                  : this.end_date || null,
                    "start_date"                : this.start_date || null,
                    "period"                     : product?.plan || null, 
                    "saved_budget"               : product?.amount         ||   null,                                     
                    "save_budget_id"             : this.dataFromCreatePage?._id             || null,
                    "document_status"            : this.dataFromCreatePage?.document_status            || null,
                    "document_status_permission" : this.dataFromCreatePage?.document_status_permission || null,
                    "discount"                   : product?.discount                                   || null,
                    "net"                        : product?.amount                                        || null,
                    "is_product_discount"        : this.isProductsDiscount                             || null
                }
                EventBus.$emit('planPettyCashModal', tempData)
                // this.$refs.PlanPettyCashModalDialog.openDialog();
            } else {
                return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
            }
        },
        cutItemName(name) {
            if (name.length > 13) {
                return `${name.substring(0, 13)}...`
            } else {
                return name
            }
        },
        checkDataSavePettyCash() {
            this.cutPettyCashData.shift()
            if (this.cutPettyCashData.length > 0) {
                this.dialog = false;
                this.open(this.cutPettyCashData)
            } else {
                EventBus.$emit('toCutPettyCashModal')
                this.dialog = false;
            }
        },
        async confirmAddSavePettyCash() {
            if (!this.$refs.savePettyCashForm.validate()) {
                return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
            }
            for (let i = 0; i < this.cutPettyCashData[0].item.length; i++) {
                if (!this.cutPettyCashData[0].item[i].plan.length) {
                    return this.alert('กรุณาบันทึก Plan ให้ครบทุกรายการ', 'Warning', 'info')
                }
            }
            if (this.editDataMode) {
                return this.editSaveBudgetAndPlanBudget()
            }
            if (this.dataFromCreatePage[0].save_budget_id) {
                let planUpdated = []
                for (let i = 0; i < this.dataFromCreatePage[0].item.length; i++) {
                    for (let j = 0; j < this.dataFromCreatePage[0].item[i].plan.length; j++) {
                        if (!_.isEqual(this.dataFromCreatePage[0].item[i].plan[j], this.cutPettyCashData[0].item[i].plan[j])) {
                            this.cutPettyCashData[0].item[i].index = i
                            planUpdated.push(this.cutPettyCashData[0].item[i])
                            j = this.dataFromCreatePage[0].item[i].plan.length
                        }
                    }
                }
                if (planUpdated.length) {
                    this.updatePlanSaveBudget(planUpdated)
                } else {
                    this.dialog = false
                }
                return 
            }
            let addSaveBudgetBody = {
                budget_end_year   : (Number(this.end_date?.split("-")[0] || '0')) || new Date().getFullYear() || null,
                budget_start_year : (Number(this.start_date?.split("-")[0] || '0')) || new Date().getFullYear() || null,
                total_budget      : this.cutPettyCashData[0].total_amount?.replace(/,/g, '') || null,
                saved_budget      : this.cutPettyCashData[0].total_amount?.replace(/,/g, '') || null,
                discount          : this.cutPettyCashData[0].discount?.replace(/,/g, '')     || null,
                net               : this.cutPettyCashData[0].net?.replace(/,/g, '')          || null,
                from              : 'petty_cash'                                             || null,
                item              : this.cutPettyCashData[0].item.map((e, index) => {
                    return {
                        "plan"       : e?.plan                                                            || null,
                        "item_id"    : index.toString()                                                   || '0',
                        "item_name"  : e?.detail                                                          || null,
                        "item_price" : e?.total_product_price.replace(/,/g, '')                           || null,
                        "discount"   : e?.discount.replace(/,/g, '')                                      || null,
                        "net"        : e?.net.replace(/,/g, '')                                           || null,
                        "group"      : e?.group?.map(e1 => (e1?.group && e1.group?.group_id?.length) && { ...e1?.group }).filter(Boolean) || null,
                        "_id"        : e?._id                                                             || null
                    }
                }),
                tax_id: this.selectedBiz.tax_id,
                start_date: this.start_date,
                end_date: this.end_date,
                in_off_budget    : typeof this.cutPettyCashData[0].in_budget === 'boolean'? this.cutPettyCashData[0].in_budget : null,
                type_budget      : this.cutPettyCashData[0].budget_type || null,
                remark           : this.cutPettyCashData[0].remark || null,
                sub_team         : this.cutPettyCashData[0].sub_team   || null,
                budget_year_type : this.type_year_selected,
                group_first_year : this.year_selected_start,
                transaction_id   : this.cutPettyCashData[0]._id || null,
                group_last_year  : this.type_year_selected === 'ภายในปี'? this.year_selected_start : this.year_selected_end
            }
            delete addSaveBudgetBody.save_budget_id
            try {
                this.loadingAddSaveBudget = true
                const { data } = await this.axios.post(`${this.$api_url}/save_budget/api/v1/add_save_budget`, addSaveBudgetBody)
                if (data.status) {
                    if (data.message === 'insufficient plan balance') {
                        return this.alert('งบประมาณไม่เพียงพอ', 'Warning', 'info')
                    }
                    this.dialog = false
                    this.alert('บันทึกงบประมาณสำเร็จ', 'Success', 'success')
                    
                }
            } catch (error) {
                console.log(error);
                this.alert('บันทึกงบประมาณไม่สำเร็จ', 'Fail', 'error')
            } finally {
                this.loadingAddSaveBudget = false
            }
        },
        getYearList() {
            const startYear = 2023; // This year has started the project.
            const currentYear = new Date().getFullYear();
            this.year_selected_start = currentYear.toString();
            this.year_selected_end = currentYear.toString();
            const result = Array.from({ length: currentYear - startYear + 1 }, (_, index) => (startYear + index).toString());
            this.$set(this.item_year, 'from', result);
            this.$set(this.item_year, 'to', result);
        },
        dateMenuReset(){
            for (let i = 0; i < this.cutPettyCashData[0].item.length; i++) {
                this.cutPettyCashData[0].item[i].plan = []
                this.cutPettyCashData[0].item[i].net =  ''
                this.cutPettyCashData[0].item[i].discount = ''
            }
        },
        alert(title = '', text = '', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text: text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            });
        },
    },
};
</script>
<style>
.card-save-petty {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 20px !important;
}

.check-box-petty-cash-modal {
    font-size: 13px;
    color: black;
}

.text-box-petty-cash-modal .v-input__control .v-input__slot {
    min-height: auto;
    padding: 0px 8px !important;
    font-size: 13px;
}

.dropdown-group-petty-cash-modal {
    border-radius: 0px;
    font-size: 13px;
}

.dropdown-group-petty-cash-modal.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height: auto;
}

.dropdown-group-petty-cash-modal.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0 4px;
}

.dropdown-group-petty-cash-modal .v-icon.v-icon {
    font-size: 15px;
}

.dropdown-group-petty-cash-modal .v-input__icon {
    min-width: auto;
    width: auto;
}

.dropdown-group-petty-cash-modal.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
    padding-top: 2px;
}

.item-group-petty-cash-modal {
    background-color: #E7E7E7;
    min-height: 28px;
    line-height: 28px;
    font-weight: 700;
    font-size: 13px;
}

.name-first-item-header-save-petty-cash-modal {
    border-radius: 10px 0px 0px 10px;
}

.name-last-item-header-save-petty-cash-modal {
    border-radius: 0px 10px 10px 0px;
}

.dropdown-external-petty-cash-modal {
    border-radius: 5px;
    font-size: 13px;
}

.dropdown-external-petty-cash-modal.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height: auto;
}

.dropdown-external-petty-cash-modal.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding-left: 8px;
    padding-right: 0px;
}

.dropdown-external-petty-cash-modal .v-icon.v-icon {
    font-size: 15px;
}

.dropdown-external-petty-cash-modal .v-input__icon {
    min-width: auto;
    width: auto;
}

.dropdown-group-heard-petty-cash-modal {
    border-radius: 0px;
    font-size: 13px;
}

.dropdown-group-heard-petty-cash-modal.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height: auto;
    border-radius: 10px 0px 0px 10px;

}

.dropdown-group-heard-petty-cash-modal.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0 4px;
    padding-left: 10px;
}

.dropdown-group-heard-petty-cash-modal .v-icon.v-icon {
    font-size: 15px;
}

.dropdown-group-heard-petty-cash-modal .v-input__icon {
    min-width: auto;
    width: auto;
}

.calendar-btn-save-petty-cash-modal {
    border-radius: 10px;
}

.calendar-btn-save-petty-cash-modal:not(.v-btn--round).v-size--default {
    min-width: auto;
    box-shadow: none;
}

.remark-textarea-save-petty-cash-modal.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0px;
}

.remark-textarea-save-petty-cash-modal {
    line-height: 24px;
    font-size: 13px;
}

.remark-textarea-save-petty-cash-modal>.v-input__control>.v-input__slot {
    min-height: 24px !important;
}

@media only screen and (max-width: 959px) {
    .name-first-item-header-save-petty-cash-modal {
        border-radius: 10px 10px 0px 0px;
    }

    .dropdown-group-heard-petty-cash-modal.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
        min-height: auto;
        border-radius: 10px 10px 0px 0px;
    }

    .name-last-item-header-save-petty-cash-modal {
        border-radius: 0px 0px 0px 10px;
    }

    .calendar-btn-save-petty-cash-modal {
        border-radius: 0px 0px 10px 0px;
    }
}
</style>
